/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import logo from "../../../assests/images/appLogo.svg";
import urls from "../../../api/urls";
const { RESEND_INVOICE, DISCOUNT_INVOICE } = urls;

import { message } from "antd";
import API from "../../../api";
import { APIs } from "../../../utils/worker";

const Table = ({ data = [], companyDetails = {}, summary = {} }) => {
  if (!data?.length) return null;

  const isRegular = companyDetails.is_regular === "1";
  // const FullAddress = isRegular
  //   ? `${companyDetails.address1 || ""} ${companyDetails.address2 || ""}, ${
  //       companyDetails.city || ""
  //     }, ${companyDetails.state || ""}`
  //   : companyDetails.gstDetails?.state_address || "";
  // const GSTNumber = isRegular
  //   ? companyDetails.IsGstRegistered
  //     ? companyDetails.gstDetails?.gst_number || "-"
  //     : "-"
  //   : companyDetails.gst || "-";

  const FullAddress = `${companyDetails.address1 || ""} ${
    companyDetails.address2 || ""
  }, ${companyDetails.city || ""}, ${companyDetails.state + " - " || ""} ${
    companyDetails.pincode || ""
  }`;
  // Currency helper
  const currency = (value) => `₹${parseFloat(value).toFixed(2)}`;

  return (
    <div style={{ background: "white", padding: "20px" }}>
      {/* Header */}
      <table width="100%">
        <tbody>
          <tr>
            <td style={{ width: "40%" }}>
              <img
                // src="https://cdn.sevasetu.in/Downloads/New_Company_Logo.png"
                src={logo}
                width="380"
                alt="Logo"
                crossOrigin="anonymous"

                // crossOrigin="https://sandbox.bookings.innofulfill.com/"
              />
            </td>
            <td style={{ width: "50%", fontSize: 14, textAlign: "end" }}>
              <b>
                SHREE MARUTI INTEGRATED LOGISTICS LIMITED
                <br />
                {FullAddress}
                {companyDetails.number && (
                  <>
                    <br />
                    Phone: {companyDetails.number}
                  </>
                )}
              </b>
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ fontSize: 14, width: "100%", marginTop: 10 }}>
        <tbody>
          <tr>
            <td>
              <b>Channel Partner:</b> {companyDetails.alias_company_name}
            </td>
            <td style={{ textAlign: "center" }}>
              <b>TAX INVOICE</b>
            </td>
            <td style={{ textAlign: "right" }}>
              <b>GST No:</b> {companyDetails?.gstDetails?.gst_number}
            </td>
          </tr>
        </tbody>
      </table>

      <table
        style={{
          fontSize: 14,
          width: "100%",
          borderTop: "1px solid #000",
          marginTop: 10,
        }}
      >
        <tbody>
          <tr>
            <td>
              <b>Name:</b> {data[0]?.pickupAddress?.name}
              <br />
              <b>Address:</b> {data[0]?.pickupAddress?.address1}
              <br />
              <b>Phone:</b> {data[0]?.pickupAddress?.phone}
              <br />
              <b>GSTIN:</b> {data[0]?.pickupAddress?.gst}
              <br />
              <b>Date:</b>{" "}
              {new Date(data[0]?.createdAt).toLocaleDateString("en-IN")}
            </td>
            <td style={{ textAlign: "right", fontWeight: "bold" }}>
              Cash Receipt
            </td>
          </tr>
        </tbody>
      </table>
      <div
        style={{
          //   textAlign: h === "Charges" ? "right" : "left",
          //   backgroundColor: "#f0f0f0",
          padding: "8px",
          borderBottom: "1px solid #000",
        }}
      ></div>

      {/* Main table */}
      <table
        className="main-content"
        style={{
          width: "100%",
          fontSize: 12,
          marginTop: 10,
        }}
        cellPadding="5"
        cellSpacing="0"
      >
        <thead style={{ fontWeight: "bold" }}>
          <tr>
            {[
              "Sr.",
              "Document No",
              // "Invoice No",
              "Service Type",
              "Receiver Name",
              "Receiver Address",

              "Type",
              "Weight",
              "Charges",
            ].map((h) => (
              <th
                key={h}
                style={{
                  textAlign: h === "Charges" ? "right" : "left",
                  //   backgroundColor: "#f0f0f0",
                  padding: "8px",
                  borderBottom: "1px solid #000",
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => {
            const grams = item.shipmentType === "DOX";

            const weight = grams
              ? `${parseInt(item?.dwsWeight).toFixed(2)} Gms`
              : `${(parseInt(item?.dwsWeight) / 1000).toFixed(2)} Kg`;

            return (
              <>
                <tr key={i}>
                  <td style={{ textAlign: "left", padding: "5px" }}>{i + 1}</td>
                  <td style={{ textAlign: "left", padding: "5px" }}>
                    {item.documentNo}
                  </td>
                  <td style={{ textAlign: "left", padding: "5px" }}>
                    {item?.deliveryPromise}
                  </td>
                  <td style={{ textAlign: "left", padding: "5px" }}>
                    {item.receiverAddress?.length > 15
                      ? item.receiverAddress.name.slice(0, 15) + "..."
                      : item.receiverAddress?.name}
                  </td>
                  <td style={{ textAlign: "left", padding: "5px" }}>
                    {item.ToCenter?.length > 15
                      ? item.receiverAddress.address1.slice(0, 15) + "..."
                      : item.receiverAddress.address1}
                  </td>

                  <td style={{ textAlign: "left", padding: "5px" }}>
                    {item.shipmentType}
                  </td>
                  <td style={{ textAlign: "left", padding: "5px" }}>
                    {weight}
                  </td>
                  <td style={{ textAlign: "right", padding: "5px" }}>
                    {currency(item.charges.totalCharge)}
                  </td>
                </tr>
              </>
            );
          })}

          {[
            // ["Total:", summary.totalCharge],
            ["Freight Charges W/O GST:", summary.subTotal],

            [
              `Discount: (${summary?.discountPercentage}%)`,
              -summary.discountAmount,
            ],
            ["SGST @9%:", summary.sgst],
            ["CGST @9%:", summary.cgst],
            ["IGST @18%:", summary.igst],
            ["CESS @1%:", summary.cess],
            ["Packaging Charges:", summary?.packagingCharge?.toFixed(2)],
            ["Net Amount:", +summary.finalAmount?.toFixed(2)],
          ].map(([label, value], idx) => (
            <>
              {/* <tr style={{ borderBottom: "1px solid #000" }}></tr> */}
              <tr key={idx}>
                <td colSpan="6"></td>
                <td style={{ textAlign: "left", padding: "5px" }}>
                  <b>{label}</b>
                </td>
                <td style={{ textAlign: "right", padding: "5px" }}>
                  <strong>{currency(value)}</strong>
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
      <div
        style={{
          //   textAlign: h === "Charges" ? "right" : "left",
          //   backgroundColor: "#f0f0f0",
          padding: "8px",
          borderBottom: "1px solid #000",
        }}
      ></div>
    </div>
  );
};

const InvoiceTable = forwardRef(
  (
    {
      selectedData,
      companyDetails,
      summary,
      loading,
      handleLoading,
      handleInvoiceModalClose,
    },
    ref
  ) => {
    const componentRef = useRef();

    const resendInvoice = async (url) => {
      let payload = {
        documentNos: selectedData.map((item) => item.documentNo),
        invoiceUrl: url,
        senderNo: String(selectedData[0]?.pickupAddress?.phone),
      };
      const response = await API.Api(DISCOUNT_INVOICE).post(payload);

      if (response.status) {
        // handleInvoiceModalClose();
        // const data = await response.json();
        handleLoading(false);
        message.success("Invoice sent successfully!");
      } else {
        handleLoading(false);
        message.error(response?.message || "Failed to resend invoice");
      }
    };

    const generateAndSendPDF = async () => {
      const element = componentRef.current;
      if (!element) {
        console.error("Ref element not found");
        return;
      }
      handleLoading(true);

      try {
        const canvas = await html2canvas(element, {
          scale: 10, // Good balance: clarity & file size
          useCORS: true,
          backgroundColor: "#ffffff",
        });

        const imgData = canvas.toDataURL("image/jpeg", 50); // Adjust quality if needed

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // First page
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // Additional pages
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        const currentDate = new Date().toISOString().split("T")[0];
        const filename = `Invoice_${currentDate}.pdf`;

        // Upload
        const pdfBlob = pdf.output("blob");
        const formData = new FormData();
        formData.append("files", pdfBlob, filename);
        const userInfo = JSON.parse(localStorage.getItem("userId"));

        const response = await axios.post(
          `${APIs.baseURL}/file-service/v1/file`,
          formData,
          {
            headers: {
              awbNumber: "123443433443",
              "SMCS-PREMISE-ID": userInfo?.userInfo?.premiseId,
            },
          }
        );
        handleInvoiceModalClose();
        resendInvoice(response.data?.data?.filePath);
        window.open(response.data?.data?.filePath, "_blank");

        // console.log("✅ Upload success", response.data?.data?.filePath);
      } catch (error) {
        handleLoading(true);
        console.error(
          "❌ PDF generation or upload failed:",
          error.response?.data || error.message
        );
      }
    };

    useImperativeHandle(ref, () => ({
      // downloadPDF: handleDownloadPDF,
      downloadPDF: generateAndSendPDF,
    }));

    return (
      <>
        <div
          style={
            {
              // position: "absolute",
              // top: "-9999px",
              // left: "-9999px",
              // visibility: "hidden", // optional
            }
          }
        >
          <div style={{ padding: 24 }} ref={componentRef}>
            <Table
              data={selectedData}
              companyDetails={companyDetails}
              summary={summary}
            />
          </div>
        </div>
        {/* <button onClick={handleDownloadPDF}>Download PDF</button> */}
        {/* <button onClick={generateAndSendPDF}>generateAndSendPDF PDF</button> */}
      </>
    );
  }
);

export default InvoiceTable;

// export default InvoiceTable;
